import {OrderProductModel} from "../Models/OrderModel";

export const useUpdateOrderWithoutDiscount = (): (p: OrderProductModel, quantity: number) => OrderProductModel => {

    return (p: OrderProductModel, quantity: number): OrderProductModel => {
        const totalPriceHT = p.unitPriceHT ? +((p.unitPriceHT * quantity).toFixed(5)) : 0
        const totalPriceTTC = p.unitPriceTTC ? +(p.unitPriceTTC * quantity).toFixed(2) : 0
        const totalDepositPriceTTC = p.unitDepositPriceTTC ? p.unitDepositPriceTTC * quantity : 0
        return {
            ...p,
            quantity,
            totalPriceHT ,
            totalPriceTTC,
            totalDepositPriceTTC,
            totalTva: totalPriceTTC - totalPriceHT,
        }
    }
}
